export default "__VITE_ASSET__Bsh1DQ3t__"